<div>Threshold</div>
<table mat-table [dataSource]="priceThreshold" class="mat-elevation-z8">
    <ng-container matColumnDef="{{column.name}}" *ngFor="let column of displayColumns">
        <th mat-header-cell *matHeaderCellDef> {{column.header}} </th>
        <td mat-cell *matCellDef="let element"> {{element[column.name]}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
</table>